export default {
  SET_COLUMNS: (state, payload) => {
    if (state.columns == null) {
      state.columns = {};
    }
    state.columns[payload.tableId] = payload.columns;
  },
};
